import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconComponent } from '@montebravo.tech/design-system-icons';
import { NgxFileDropModule } from 'ngx-file-drop';
import { SnackBarService } from '../../services/snack-bar.service';
import { SnackBarComponent } from '../snackbar/snackbar.component';
import { UploadFileComponent } from './upload-file.component';

@NgModule({
    declarations: [UploadFileComponent],
    imports: [
        CommonModule,
        NgxFileDropModule,
        SnackBarComponent,
        IconComponent,
    ],
    exports: [UploadFileComponent],
    providers: [SnackBarService],
})
export class UploadFileModule {}
